import React from 'react';
import Loader from 'react-simple-loading';

import PaymentMessage from './PaymentMessage';


function PaymentContent(props) {
  const {
    loading,
    anchorFirstName,
    anchorImage,
    isRenewal,
    processing,
    productType,
    subNotActive,
  } = props;

  if (loading) {
    return (
      <div className="checkout-container__loader">
        <Loader />
      </div>
    );

  }

  return (
    <React.Fragment>
      <div className="checkout-image-holder">
        <img alt="Naked News" className="full" src={anchorImage} />
      </div>
      <div className="checkout-message">
        <PaymentMessage
          anchorFirstName={anchorFirstName}
          isRenewal={isRenewal}
          processing={processing}
          productType={productType}
          subNotActive={subNotActive}
        />
      </div>
    </React.Fragment>
  );
}

export default PaymentContent;
